import { render, staticRenderFns } from "./WorkExperience.vue?vue&type=template&id=a2973534&scoped=true&"
import script from "./WorkExperience.vue?vue&type=script&lang=js&"
export * from "./WorkExperience.vue?vue&type=script&lang=js&"
import style0 from "./WorkExperience.vue?vue&type=style&index=0&id=a2973534&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2973534",
  null
  
)

export default component.exports